import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { getContent } from '../../util/responseUtil';
import API_CONTACT from '../../api/apiContact';

class FilterTicketMember extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilter: false,
            customerService: {
                page: 1,
                limit: 100,
                data: [],
                value: []
            },
        }
    }

    getListCustomerService = () => {
        API_CONTACT.getListCustomerServiceMember(this.state.customerService.page, this.state.customerService.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        customerService: {
                            ...this.state.customerService,
                            data: getContent(res)
                        }
                    });
                }
            })
    }

    handleFilter = () => {
        this.setState({
            showFilter: false
        })
        this.props.handleFilter(this.state.customerService.value)
    }

    handleResetFilter = () => {
        this.setState({
            showFilter: false,
            customerService: {
                ...this.state.customerService,
                value: []
            }
        })
        this.props.resetFilter()
    }

    handleChangeCustomerService = data => {
        this.setState({
            customerService: {
                ...this.state.customerService,
                value: data.map(data => (data.value))
            }
        })
    }

    componentDidMount() {
        this._isMounted = true;
        this.filterButtonRef = createRef();
        this.filterRef = createRef();


        this.getListCustomerService();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showFilter !== this.state.showFilter) {
            if (this.state.showFilter) {
                document.addEventListener('click', this.handleCollapseFilter)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener('click', this.handleCollapseFilter);
    }

    render() {
        const animatedComponents = makeAnimated();

        return (
            <div className="inline-block relative">
                <div
                    className="rounded-full bg-white text-darkblue font-bold shadow-lg border-2 border-white px-8 py-2 mr-5 flex justify-between items-center cursor-pointer"
                    id="btnfilterticketmember"
                    onClick={() => this.setState({ showFilter: !this.state.showFilter })}
                    ref={this.filterButtonRef}
                >
                    <p className="mr-2">Filter</p>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>
                {
                    this.state.showFilter &&
                    <div className="absolute bg-white shadow-lg rounded-lg mt-4 w-80 text-gray-600 select-none z-50 p-5" ref={this.filterRef}>
                        <label>Nama CS</label>
                        <Select
                            id="mlscustomerservicename"
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            placeholder="Pilih Nama CS"
                            options={this.state.customerService.data.map(data => ({ value: data.user_nexcare_id, label: data.name }))}
                            onChange={this.handleChangeCustomerService}
                        />
                        <div className="flex justify-between items-center my-3">
                            <button
                                type="button"
                                id="btnreset"
                                className="bg-darkred rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleResetFilter()}
                            >
                                Reset
                            </button>
                            <button
                                type="button"
                                id="btnfilter"
                                className="bg-lightblue rounded text-white focus:outline-none py-0.5 px-5"
                                onClick={() => this.handleFilter()}
                            >
                                Terapkan
                            </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(FilterTicketMember);